import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("MediaUpdateOutput")
export class MediaUpdateOutput {
    @JsonProperty("status", Boolean)
    public status: boolean = JsonPropertyEmpty;
}
